import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  Reference,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformIpContract } from './ip-contracts.transformers';
import { IpContractsCollection } from './ip-contracts.types';

export function ipContractsReducer(
  state: CollectionStateSlice<IpContractsCollection> = {},
  action: CollectionActions<IpContractsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'ipContracts') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<IpContractsCollection>(
          state,
          transformIntoDocuments(result.contracts, transformIpContract),
          order,
          ref,
        );
      }
      return state;
    }
    case 'WS_MESSAGE': {
      const ref: Reference<IpContractsCollection> = {
        path: {
          collection: 'ipContractsCollection',
          authUid: action.payload.toUserId,
        },
      };
      if (action.payload.parent_type === 'notifications') {
        switch (action.payload.type) {
          case 'ipContractUpdate': {
            return mergeWebsocketDocuments<IpContractsCollection>(
              state,
              transformIntoDocuments(action.payload.data, transformIpContract),
              ref,
            );
          }
          default:
            return state;
        }
      }
      return state;
    }
    default:
      return state;
  }
}
